import React, { Fragment, useRef, useState } from 'react'
import classes from './InputWithEdit.module.css'
import edit from '../../assets/img/edit-filled.png' 

const InputWithEdit = ({value,value1, id, ...rest}) => {
    const [inputDisable, setInputDisable] = useState(true);
    const inputRef = useRef(null)
    const editHandler = () => {
      setInputDisable(false);
      setTimeout(() => {
        inputRef.current.focus();
      }, 50);
    };
    const onBlurHandler = () => {
    if({value} === 0 || {value1} === 0){
        return;
    }
      setInputDisable(true)
    }
  return (
    <Fragment>
      <div className={classes.inputGroup}>
      {
        inputDisable
        ?
        <div className={`${classes.input} ${classes.disable}`}>{value1}</div>
        :
        <input
        id={id}
        ref={inputRef}
        className={classes.input}
        //onChange={usernameChange}
        value={value}
        onBlur={onBlurHandler}
        {...rest}
      />
      }
      <img style={{display:`${inputDisable ? 'inline' : 'none'}`}} src={edit} alt="Edit" onClick={editHandler} />
      </div>
    </Fragment>
  )
}

export default InputWithEdit